import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
// import Select from "react-select";

const PreviousEducationDetails = ({ formData, setFormData }) => {
  const { id } = useParams();
  const currentDate = new Date().toISOString().split("T")[0];
  const selectedClassName = String(
    formData.classname || formData.className || ""
  )
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
  const isClassOneStudent = ["1", "class1", "1st", "class1st"].includes(
    selectedClassName
  );

  // Local state initialized with one empty row by default
  const [previousEducation, setPreviousEducation] = useState(() => {
    return formData.previousEducationDetails &&
      formData.previousEducationDetails.length > 0
      ? formData.previousEducationDetails
      : [
        {
          nameofschool: "",
          location: "",
          class_completed: "",
          year_from: "",
          year_to: "",
          language_of_instruction: "",
          transfer_certificate: "",
          result: "",
        },
      ];
  });

  // Ensure blank row when cleared
  useEffect(() => {
    if (!formData.previousEducationDetails || formData.previousEducationDetails.length === 0) {
      const blankRow = [{
        nameofschool: "",
        location: "",
        class_completed: "",
        year_from: "",
        year_to: "",
        language_of_instruction: "",
        transfer_certificate: "",
        result: "",
      }];
      setPreviousEducation(blankRow);
      setFormData((prevFormData) => ({
        ...prevFormData,
        previousEducationDetails: blankRow,
      }));
    } else {
      setPreviousEducation(formData.previousEducationDetails);
    }
  }, [formData.previousEducationDetails, setFormData]);


  // Fetch previous education details only once when the component mounts, if not already in formData
  // useEffect(() => {
  //     if (!formData.previousEducationDetails || formData.previousEducationDetails.length === 0) {
  //         const fetchPreviousEducationDetails = async () => {
  //             try {
  //                 const response = await fetch(`${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`);
  //                 const result = await response.json();

  //                 if (result.data && result.data.previous_education_details) {
  //                     setPreviousEducation(result.data.previous_education_details);
  //                     setFormData(prevFormData => ({
  //                         ...prevFormData,
  //                         previousEducationDetails: result.data.previous_education_details
  //                     }));
  //                 }
  //             } catch (error) {
  //                 console.error('Error fetching previous education details:', error);
  //             }
  //         };

  //         fetchPreviousEducationDetails();
  //     }
  // }, [id, formData.previousEducationDetails, setFormData]);

  // useEffect(() => {
  //   if (
  //     id &&
  //     (!formData.previousEducationDetails ||
  //       formData.previousEducationDetails.length === 0)
  //   ) {
  //     const fetchPreviousEducationDetails = async () => {
  //       try {
  //         const response = await fetch(
  //           `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
  //         );
  //         const result = await response.json();

  //         if (result.data && result.data.previous_education_details) {
  //           setPreviousEducation(result.data.previous_education_details);
  //           setFormData((prevFormData) => ({
  //             ...prevFormData,
  //             previousEducationDetails:
  //               result.data.previous_education_details,
  //           }));
  //         }
  //       } catch (error) {
  //         console.error("Error fetching previous education details:", error);
  //       }
  //     };

  //     fetchPreviousEducationDetails();
  //   }
  // }, [id, formData.previousEducationDetails, setFormData]);

  useEffect(() => {
    if (id) {
      const fetchPreviousEducationDetails = async () => {
        try {
          const response = await fetch(
            `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
          );
          const result = await response.json();

          if (result.data && result.data.previous_education_details) {
            setPreviousEducation(result.data.previous_education_details);
            setFormData((prevFormData) => {
              // Only update if empty (prevent infinite loop)
              if (
                !prevFormData.previousEducationDetails ||
                prevFormData.previousEducationDetails.length === 0
              ) {
                return {
                  ...prevFormData,
                  previousEducationDetails:
                    result.data.previous_education_details,
                };
              }
              return prevFormData; // Don't change if already present
            });
          }
        } catch (error) {
          console.error("Error fetching previous education details:", error);
        }
      };

      fetchPreviousEducationDetails();
    }
  }, [id]);

  // Handle addition of a new row
  const handleAddRow = () => {
    if (isClassOneStudent) {
      return;
    }

    setPreviousEducation((prev) => [
      ...prev,
      {
        nameofschool: "",
        location: "",
        class_completed: "",
        year_from: "",
        year_to: "",
        language_of_instruction: "",
        transfer_certificate: "",
        result: "",
        isNew: true, // ✅ mark as new
      },
    ]);
  };

  // Handle removal of a row
  const handleRemoveRow = (index) => {
    if (isClassOneStudent) {
      return;
    }

    const selectedRow = previousEducation[index];
    if (!selectedRow?.isNew) {
      alert("Only newly added rows can be removed.");
      return;
    }

    const updatedRows = previousEducation.filter((_, i) => i !== index);
    setPreviousEducation(updatedRows);
    setFormData((prevFormData) => ({
      ...prevFormData,
      previousEducationDetails: updatedRows,
    }));
  };

  // Handle changes in individual row fields and update both local and parent state
  const handleInputChange = (index, field, value) => {
    if (isClassOneStudent) {
      return;
    }

    if (field === "year_to" && value && value > currentDate) {
      alert("Years Attended To cannot be greater than current date.");
      return;
    }

  //   const row = previousEducation[index] || {};
  //   const yearFrom = field === "year_from" ? value : row.year_from;
  //   const yearTo = field === "year_to" ? value : row.year_to;

  //   if (yearFrom && yearTo && yearFrom > yearTo) {
  //     alert("Years Attended To must be greater than or equal to Years Attended From.");
  //     return;
  //   }

  //   const updatedRows = previousEducation.map((row, i) =>
  //     i === index ? { ...row, [field]: value } : row
  //   );
  //   setPreviousEducation(updatedRows);
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     previousEducationDetails: updatedRows,
  //   }));
  // };

  const row = previousEducation[index] || {};
    const yearFrom = field === "year_from" ? value : row.year_from;
    const yearTo = field === "year_to" ? value : row.year_to;

    if (yearFrom && yearTo && yearFrom > yearTo) {
      alert("Years Attended To must be greater than or equal to Years Attended From.");
      return;
    }

    const updatedRows = previousEducation.map((row, i) =>
      i === index ? { ...row, [field]: value } : row
    );
    setPreviousEducation(updatedRows);
    setFormData((prevFormData) => ({
      ...prevFormData,
      previousEducationDetails: updatedRows,
    }));
  };
// ddddd
  return (
    <div className="container-fluid form-container">
      {isClassOneStudent ? (
        <div className="alert alert-info mb-3" role="alert">
          Previous education details are not required for Class 1 students because they do not have prior academic records before admission.
        </div>
      ) : null}

      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>
                Name Of School <span className="red-text">*</span>
              </th>
              <th>Location</th>
              <th>Class Completed</th>
              <th>
                Years Attended From <span className="red-text">*</span>
              </th>
              <th>
                Years Attended To <span className="red-text">*</span>
              </th>
              <th>Language of Instruction</th>
              <th>Transfer Certificate Provided</th>
              <th>Result</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {(previousEducation.length === 0 ? [0] : previousEducation).map(
              (row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <input
                      type="text"
                      value={row?.nameofschool || ""}
                      disabled={isClassOneStudent}
                      onChange={(e) =>
                        handleInputChange(index, "nameofschool", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={row?.location || ""}
                      disabled={isClassOneStudent}
                      onChange={(e) =>
                        handleInputChange(index, "location", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={row?.class_completed || ""}
                      disabled={isClassOneStudent}
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "class_completed",
                          e.target.value
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="date"
                      value={row?.year_from || ""}
                      disabled={isClassOneStudent}
                      onChange={(e) =>
                        handleInputChange(index, "year_from", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="date"
                      value={row?.year_to || ""}
                      max={currentDate}
                      disabled={isClassOneStudent}
                      onChange={(e) =>
                        handleInputChange(index, "year_to", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={row?.language_of_instruction || ""}
                      disabled={isClassOneStudent}
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "language_of_instruction",
                          e.target.value
                        )
                      }
                    />
                  </td>
                  {/* <td>
                    <select
                      value={row?.transfer_certificate || ""}
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "transfer_certificate",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Select</option>
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                    </select>
                  </td> */}

                  
                  <td>
  <select
    className="form-control"
    value={row?.transfer_certificate || ""}
    disabled={isClassOneStudent}
    onChange={(e) =>
      handleInputChange(
        index,
        "transfer_certificate",
        e.target.value
      )
    }
  >
    <option value="">Select</option>
    <option value="Y">Yes</option>
    <option value="N">No</option>
  </select>
</td>
                  <td>
                    <input
                      type="text"
                      value={row?.result || ""}
                      disabled={isClassOneStudent}
                      onChange={(e) =>
                        handleInputChange(index, "result", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-danger"
                      disabled={isClassOneStudent}
                      onClick={() => handleRemoveRow(index)}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleAddRow}
          disabled={isClassOneStudent}
        >
          Add New Row
        </button>
      </div>
    </div>
  );
};

export default PreviousEducationDetails;
